module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "uk-container uk-container-small uk-flex uk-flex-wrap uk-margin-top uk-margin-bottom"
  }, [_c('div', {
    staticClass: "uk-width uk-text-center",
    domProps: {
      "textContent": _vm._s(_vm.config.footer_text)
    }
  }, [_vm._v("\n    " + _vm._s(_vm.config.footer_text) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32a4d8ee","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/footer.vue
// module id = 241
// module chunks = 1